module.exports = __webpack_public_path__ + "static/media/Handbags_Thumb_1.2730b647.jpg";